import { defineStore } from 'pinia';
import type { PagesMenu } from '@/types/pagesMenu';

export const useAllowedMenus = defineStore(
  'allowedMenus',
  () => {
    const menus = ref<PagesMenu[]>([]);
    function setMenus(newMenus: PagesMenu[]) {
      menus.value = newMenus;
    }


    return {
      menus,
      setMenus,
    };
  },
  {
    persist: true,
  }
);

// //@ts-ignore
// if (import.meta.hot) {
//   //@ts-ignore
//   import.meta.hot.accept(acceptHMRUpdate(useAllowedMenus, import.meta.hot));
// }
